import React, { useMemo } from 'react'
import SkeletonComponent from './SkeletonComponent.jsx';
import 'react-loading-skeleton/dist/skeleton.css'

const ButtonSkeleton = ({ buttonContent, size='md', className='', style = {} }) => {
  const width = `${(buttonContent || 'content').length}ch`;

  const borderRadius = useMemo(() => {
    if (size === 'md') {
      return '18px';
    }
    if (size === 'lg') {
      return '22px';
    }
    return '16px';
  }, [size])

  return (
    <button
      disabled
      style={{
        // padding: '0.5em 1em',
        borderRadius: borderRadius,
        border: 'none',
        background: '#f2f2f2',
        cursor: 'not-allowed',
        ...style
      }}
      className={`btn btn-${size} ${className}`}
    >
      <SkeletonComponent width={width} height="1em" />
    </button>
  )
}

export default ButtonSkeleton;